export const truncateCoreId = (userCoreID: string, size = 4) =>
  `${userCoreID.slice(0, size)}...${userCoreID.slice(-size)}`;
